import type { User } from "../../services/api";
import type { FamilySearchIndexEntry } from "../../services/api/family";
import { familyChildName } from "../family/familySearch";
import { nameMatches } from "./nameMatches";

/** How many Users, and how many families, instant search lists. */
const PEOPLE_RESULTS = 5;

/** Users whose name matches what's being typed, for instant search. */
export function searchUsers(text: string, users: User[]): User[] {
  return users.filter((user) => user.name && nameMatches(user.name, text)).slice(0, PEOPLE_RESULTS);
}

/**
 * Families whose child's name matches what's being typed, once each, for
 * instant search. Each opens Users searched for the child, which lists the guardians.
 */
export function searchFamilies(text: string, children: FamilySearchIndexEntry[]): string[] {
  const names = children.map(familyChildName).filter((name) => nameMatches(name, text));
  return Array.from(new Set(names)).slice(0, PEOPLE_RESULTS);
}
